import React from "react";
import { Navigate } from "react-router-dom";

const PublicOnlyRoute = ({ children }) => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const jwtToken = localStorage.getItem("jwt_token");

    // Si déjà connecté, redirige vers accueil
    if (userData && jwtToken) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default PublicOnlyRoute;